import * as React from "react";
const Minus = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M20,12 L20,13 L5,13 L5,12 L20,12 Z" }));
Minus.displayName = "Minus";
var Minus_default = Minus;
export {
  Minus_default as default
};
